import urls from './urls';
import axios from 'axios';
import { IApiResponse } from 'redhotpie-shared-lib/interfaces/IApiResponse';
import IceBreaker from '../models/iceBreaker';

class iceBreakerApi {
  static loadAll(): Promise<IApiResponse> {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    // return this.restClient.execute(urls.ICE_BREAKER_LOAD_ALL, ApiMethod.GET);
    return axios.get(urls.ICE_BREAKER_LOAD_ALL, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }
}

export default iceBreakerApi;
